import speakingurl from 'speakingurl'

import Representative from './Representative'

import PowerProject, { POWER_TOTAL } from './PowerProject'
import OtherProject from './OtherProject'

class Riding {
  constructor (obj, jurisdiction) {
    this._projects = {}
    this._powerProjects = {}
    this._otherProjects = {}
    this._powerProjectTotals = PowerProject.emptyProjectTypes()
    this.name = obj.District_name

    this.party = obj.Party_name
    this.partyShortName = obj.Party_short_name

    this.rep = new Representative(obj)
    this.id = speakingurl(this.name)

    this.province = obj.Province
    this.provinceCode = obj.Province_code
    this.jurisdiction = jurisdiction || this.provinceCode.toLowerCase()

    this._initPowerProjectTotals()
  }

  _initPowerProjectTotals () {
    Object.values(this._powerProjectTotals).forEach(v => {
      v.count = 0
      v.totalMW = 0
    })
    this._powerProjectTotals[POWER_TOTAL] = {
      icon: 'fa fa-bolt',
      key: POWER_TOTAL,
      shortName: 'Total',
      count: 0,
      totalMW: 0
    }
  }

  addProject (project) {
    this._projects[project.id] = project
    if (project instanceof PowerProject) {
      this._powerProjects[project.id] = project
      this._updatePowerTotals(project)
    }
    if (project instanceof OtherProject) this._otherProjects[project.id] = project
  }

  projectArray () {
    return Object.values(this._projects)
  }

  powerProjectArray () {
    return Object.values(this._powerProjects)
  }

  otherProjectArray () {
    return Object.values(this._otherProjects)
  }

  powerProjectTotals () {
    return this._powerProjectTotals
  }

  powerProjectStat (projectType) {
    return this._powerProjectTotals[projectType]
  }

  URL () {
    return `/ridings/${this.jurisdiction}/${this.id}`
  }

  _updatePowerTotals (project) {
    const powerTotal = this._powerProjectTotals[project.renewableType]
    powerTotal.count++
    powerTotal.totalMW += project.renewableMW

    this._powerProjectTotals[POWER_TOTAL].count++
    this._powerProjectTotals[POWER_TOTAL].totalMW += project.renewableMW
  }
}

export default Riding



// WEBPACK FOOTER //
// ./src/models/Riding.js